import { Link } from 'react-router';
import { CheckCircle2, ArrowRight } from 'lucide-react';

/**
 * Shown at the top of a course once it reaches 100%. Kattia/Walter: a completed
 * course still "felt" unfinished without an explicit close-out action, so this
 * confirms completion and offers a clear way back to the course list.
 */
export function CourseCompleteBanner({ percent }: { percent: number }) {
  if (percent < 100) return null;

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-green-300 bg-green-50 p-4 dark:border-green-800 dark:bg-green-900/20 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2">
        <CheckCircle2 className="h-5 w-5 shrink-0 text-green-600 dark:text-green-400" />
        <p className="text-sm font-semibold text-green-800 dark:text-green-300">
          ¡Capacitación completada!
        </p>
      </div>
      <Link
        to="/courses"
        className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-green-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-green-700"
      >
        Volver a Mis Cursos
        <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
